import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'reports.ordersummary',
  path: '/reports/ordersummary',
    title: 'Open Order Summary',
    component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);